import type { ComponentProps } from 'react';

import { cn } from '../cn';

type InputProps = ComponentProps<'input'> & {
  invalid?: boolean;
};

/**
 * Visually matched to libs/ui/forms/src/Inputs/Input.module.scss. `invalid`
 * turns the border scarlet and sets `aria-invalid` with it. This is the field
 * alone; the old styles also had a wrapper for prefixes and suffixes.
 */
export const Input = ({ invalid, className, ...props }: InputProps) => (
  <input
    aria-invalid={invalid === true ? true : undefined}
    className={cn(
      'paragraph-lg h-9 w-full min-w-0 rounded-lg border bg-white px-4 py-2 text-slate-950 shadow-sm lg:h-12',
      'placeholder:text-slate-400 focus-visible:border-periwinkle focus-visible:outline-none',
      'disabled:cursor-not-allowed disabled:opacity-50',
      invalid === true ? 'border-scarlet' : 'border-slate-400/75',
      className,
    )}
    {...props}
  />
);
